import classNames from "classnames"
import React from "react"

import GatsbyStoryblokImage from "../../elements/V2/GatsbyStoryblokImage"
import Section from "../../elements/V2/Section"
import LayoutItem from "../Layouts/LayoutItem"

import { getBackgroundColorClass } from "@utils/V2/color"
import { Color } from "constants/V2/color"

type Props = {
  backgroundColor: Color
  imageUrl: string
  imageAlt: string
  rounded?: boolean
  mobileGridOrder?: number
}

const PaymentLogo = ({
  backgroundColor,
  imageUrl,
  imageAlt,
  rounded = true,
  mobileGridOrder,
  ...props
}: Props) => {
  return (
    <LayoutItem
      as={Section}
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        "relative flex items-center justify-center overflow-hidden pt-0 md:pt-64",
        {
          "rounded-t-xl -mt-xl": rounded,
        }
      )}
      mobileGridOrder={mobileGridOrder}
      {...props}
    >
      <GatsbyStoryblokImage
        aspectRatio="fullWidth"
        loadType="eager"
        image={imageUrl}
        alt={imageAlt || "Payment logo"}
        className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
      />
    </LayoutItem>
  )
}

export default PaymentLogo
